import React from "react";
import Fieldset from "../../common/Fieldset";
import TextInput from "../../common/TextInput";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SelectInput from "../../common/SelectInput";
import Row from "../../common/Row";
import NumberInput from "../../common/NumberInput";
const WerkInformatieFormItem = (props) => {
    const { onChange, model, errors } = props;

    return (
        <div>
            <Fieldset>
                <Row>
                    <NumberInput
                        name="aantalWerknemers"
                        label="Aantal werknemers"
                        value={model.aantalWerknemers}
                        originalValue={model.aantalWerknemers}
                        dontParse
                        onChange={onChange}
                        validationMessage={errors ? errors['aantalWerknemers'] : ""}
                    />
                </Row>
                <Row>
                    <NumberInput
                        name="vestiging"
                        label="Aantal vestigingen in Vlaanderen en Brussel"
                        value={model.vestiging}
                        originalValue={model.vestiging}
                        dontParse
                        onChange={onChange}
                        validationMessage={errors ? errors['vestiging'] : ""}

                    />
                </Row>

                <Row>
                    <SelectInput
                        name="profitNonProfit"
                        label="Profit/ Non-profit"
                        value={model.profitNonProfit}
                        items={props.profitNonProfits || []}
                        onChange={onChange}
                        validationMessage={errors ? errors['profitNonProfit'] : ""}
                        size={12}
                    />
                </Row>
                <Row>
                    <SelectInput
                        name="sector"
                        label="Sector"
                        value={model.sector}
                        items={props.sectoren || []}
                        onChange={onChange}
                        validationMessage={errors ? errors['sector'] : ""}
                        size={12}

                    />
                </Row>
                <Row>
                    <SelectInput
                        name="preventieDienst"
                        label="Preventiedienst"
                        value={model.preventieDienst}
                        items={props.preventieDiensten || []}
                        onChange={onChange}
                        validationMessage={errors ? errors['preventieDienst'] : ""}
                        size={12}
                    />
                </Row>
                <Row>
                    <SelectInput
                        name="aangeslotenBij"
                        label="Aangesloten bij"
                        value={model.aangeslotenBij}
                        items={props.aangeslotenBijs || []}
                        onChange={onChange}
                        validationMessage={errors ? errors['aangeslotenBij'] : ""}
                        size={12}
                    />
                </Row>
            </Fieldset>
        </div>
    );
};

WerkInformatieFormItem.propTypes = {
    onChange: PropTypes.func,
    model: PropTypes.object,
    aangeslotenBijs: PropTypes.array,
    preventieDiensten: PropTypes.array,
    profitNonProfits: PropTypes.array,
    sectoren: PropTypes.array,
    errors: PropTypes.array
};

function mapStateToProps(state) {
    return {
        aangeslotenBijs: state.referentie.aangeslotenBijs,
        preventieDiensten: state.referentie.preventieDiensten,
        profitNonProfits: state.referentie.profitNonProfits,
        sectoren: state.referentie.sectoren
    };
}


export default connect(mapStateToProps)(WerkInformatieFormItem);